var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isLoading)?_c('Preloader'):_vm._e(),_c('Filters',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowBulkDownload),expression:"isShowBulkDownload"}],attrs:{"textButtonSubmit":"Download","data":_vm.filters,"withGroups":"","isLoading":_vm.isLoading},on:{"submit":function($event){return _vm.downloadArchive($event, false)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }